import { createStore } from 'vuex'

export default createStore({
  state: {
    aes1: '1019E2991V09O17L1019E2991V09O17L',
    aes2: '1019E2991V09O17L',
    isLoading: false,
    alwaysLoading: false,
    flowType: '',
    showRemindImg: false,
    callBackUrl: '',
    callBackUrlApim: '',
    requestId: '',
    sessionId: '',
    otpFlag: '',
    // 錯誤導頁計時器
    errorPageCounter: null,
    card: '',
    // queryString取得
    Act: '',
    jwt: '',
    // 核准序號
    labelApproveCode: '',
    // 申請條件說明
    conditionTitle: '',
    conditionUrl: '',
    // 新舊啟用頁
    homePage: ''
  },
  mutations: {
    setAlwaysLoadingTrue (state) {
      state.alwaysLoading = true
    },
    setAlwaysLoadingFalse (state) {
      state.alwaysLoading = false
    },
    showLoading (state) {
      state.isLoading = true
    },
    hideLoading (state) {
      if (!state.alwaysLoading) {
        state.isLoading = false
      }
    },
    setFlowType (state, value) {
      state.flowType = value
    },
    setCallBackUrl (state, value) {
      state.callBackUrl = value
    },
    setCallBackUrlApim (state, value) {
      state.callBackUrlApim = value
    },
    showRemindImg (state) {
      state.showRemindImg = true
    },
    setRequestId (state, value) {
      state.requestId = value
    },
    setSessionId (state, value) {
      state.sessionId = value
    },
    setOtpFlag (state, value) {
      state.otpFlag = value
    },
    setCardId (state, value) {
      state.card = value
    },
    setJwt (state, value) {
      state.jwt = value
    },
    // 更新state Act資料
    setAct (state, value) {
      state.Act = value
    },
    setLabelApproveCode (state, value) {
      state.labelApproveCode = value
    },
    setConditionTitle (state, value) {
      state.conditionTitle = value
    },
    setConditionUrl (state, value) {
      state.conditionUrl = value
    },
    setHomePage (state, value) {
      state.homePage = value
    }
  },
  actions: {
  },
  modules: {
    routeTransfer: {
      namespaced: true,
      state: () => ({
        data: null
      }),
      mutations: {
        update (state, value) {
          state.data = value
        },
        reset (state) {
          state.data = null
        }
      }
    }
  },
  getters: {
    getAes1: state => {
      return state.aes1
    },
    getAes2: state => {
      return state.aes2
    },
    getJwt: state => {
      return state.jwt
    },
    // 取得state Act資料
    getAct: state => { return state.Act },
    // 取得state cardId資料
    getCardId: state => { return state.card },
    // 取得state callBackUrl
    getCallBackUrl: state => { return state.callBackUrl },
    // 取得state labelApproveCode資料
    getLabelApproveCode: state => {
      return state.labelApproveCode
    },
    // 取得state conditionTitle資料
    getConditionTitle: state => {
      return state.conditionTitle
    },
    // 取得state conditionMsg資料
    getConditionUrl: state => {
      return state.conditionUrl
    },
    // 取得新舊啟用頁
    getHomePage: state => {
      return state.homePage
    }
  }
})
